// extracted by mini-css-extract-plugin
module.exports = {"tab":"tabs_tab__6d780","list":"tabs_list__6RTlB"};